import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-descarga-app',
  templateUrl: './descarga-app.component.html',
  styleUrls: ['./descarga-app.component.scss']
})
export class DescargaAppComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
